// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SimpleErrorMessage-module__errorMessage__AQfPP {\n  color: var(--color-red);\n}\n", "",{"version":3,"sources":["webpack://./src/common/components/SimpleErrorMessage.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB","sourcesContent":[".errorMessage {\n  color: var(--color-red);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": "SimpleErrorMessage-module__errorMessage__AQfPP"
};
export default ___CSS_LOADER_EXPORT___;
